// utils/fullscreen.ts

export const enterFullscreen = (element: HTMLElement) => {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if ((element as any).mozRequestFullScreen) { /* Firefox */
    (element as any).mozRequestFullScreen();
  } else if ((element as any).webkitRequestFullscreen) { /* Chrome, Safari and Opera */
    (element as any).webkitRequestFullscreen();
  } else if ((element as any).msRequestFullscreen) { /* IE/Edge */
    (element as any).msRequestFullscreen();
  }
};

export const exitFullscreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if ((document as any).mozCancelFullScreen) { /* Firefox */
    (document as any).mozCancelFullScreen();
  } else if ((document as any).webkitExitFullscreen) { /* Chrome, Safari and Opera */
    (document as any).webkitExitFullscreen();
  } else if ((document as any).msExitFullscreen) { /* IE/Edge */
    (document as any).msExitFullscreen();
  }
};

export const isFullscreen = (): boolean => {
  return !!(
    document.fullscreenElement ||
    (document as any).webkitFullscreenElement ||
    (document as any).mozFullScreenElement ||
    (document as any).msFullscreenElement
  );
};
